import React from 'react';
import User, { Company } from '../../../interfaces/users.interface';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { patchCompany } from '../../../services/company';
import { getCompanyUsers } from '../../../services/companyDetail';
import { useCompanyResource } from '../../Vendors/useCompanyResource';

const ALL = 9999;

export default function CompanyPrimaryContactButton(props: { company: Company, companyCallback: any }) {
  const {
    company,
    companyCallback,
  } = props;
  // The header's company comes from the lean detail endpoint (no employees), so
  // fetch the candidate primary contacts here. This button only mounts inside the
  // Edit Company modal, so the request is on-demand.
  const { items: employees } = useCompanyResource<User>(getCompanyUsers, company.id, 1, ALL);
  const handleCompanyPrimaryContact = (event: SelectChangeEvent) => {
    if (!company.id) return;
    // Lean PATCH: only the primary contact changes.
    patchCompany(company.id, { primaryContactUser: event.target.value }).then((responseCompany: Company) => {
      companyCallback(responseCompany);
    });
  };

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="company-primary-contact">Primary Contact</InputLabel>
        <Select
          labelId="company-primary-contact"
          id="company-primary-contact-select"
          label="Primary Contact"
          onChange={handleCompanyPrimaryContact}
          defaultValue={company.primaryContactUser?.id?.toString()}
        >
          {employees.filter(e => e.firstName?.length > 0 || e.lastName?.length > 0).map((employee: User) => <MenuItem key={employee.id} value={employee.id} selected={true}>{employee.firstName} {employee.lastName}: {employee.email}</MenuItem>)}
        </Select>
      </FormControl>
      <Typography variant='caption' sx={{ mt: 1, display: 'block' }}>Primary contact user must have entered their name into their user info page</Typography>
    </>
  );
}